import { ListImage, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import {
  BrowsedJobDetailsContainerStyled,
  UploadedLogosContainerStyled,
} from './style';

type Props = {
  sizeOfDrawing: string;
  frameColor: string;
  uploadedLogos: { URL: string; id: string }[];
  resolutionOfLogo: string;
  materialTypeOfDrawing: string;
  roundedEdge: string;
};

const RequirementInformation = ({
  uploadedLogos,
  materialTypeOfDrawing,
  resolutionOfLogo,
  roundedEdge,
  frameColor,
  sizeOfDrawing,
}: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        CLIENT REQUIREMENT
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Size of Drawing :</Typography>
          <Typography className="value">{sizeOfDrawing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Selected Frame Color :</Typography>
          <Typography className="value">{frameColor}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Uploaded Logo :</Typography>
          <UploadedLogosContainerStyled className="value">
            <ListImage
              imagesURL={uploadedLogos}
              imageHeight="143px"
              imageWidth="192px"
            />
          </UploadedLogosContainerStyled>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Resolution of Logo :</Typography>
          <Typography className="value">{resolutionOfLogo}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Material Type of Drawing :</Typography>
          <Typography className="value">{materialTypeOfDrawing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Rounded Edge :</Typography>
          <Typography className="value">{roundedEdge}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default RequirementInformation;
